import { combineReducers } from 'redux'

import anexosAdiantamentosSuprimentos from './anexosAdiantamentosSuprimentos'

export default combineReducers({ anexosAdiantamentosSuprimentos })
